import { getProductCollectionsJson } from '../sections/product-page/helpers';

export default class Breadcrumbs {
  elements;
  
  constructor() {
    this.elements = {
      breadcrumbsContainers: document.querySelectorAll('.breadcrumbs'),
      breadcrumbsDynamic: document.querySelectorAll('.breadcrumbs__dynamic'),
    };

    if (this.elements.breadcrumbsContainers.length > 0 && this.elements.breadcrumbsDynamic.length > 0) {
      this.init();
    }
  }

  init = () => {
    const product_collections_json = getProductCollectionsJson();

    let previous_collection_handle = '';
    let previous_collection_title = '';
    if (!document.referrer.includes('/collections/')) {
      return;
    }

    // window.localStorage.getItem('previous-page')
    const previous_collection_parts = document.referrer.split('/');

    // ["https:", "", "www.astrthelabel.com", "collections", "whats-new"]
    if (previous_collection_parts.length >= 5) {
      previous_collection_handle = previous_collection_parts[4].split('?')[0];

      const previous_collection = product_collections_json.find((collection) => collection.handle === previous_collection_handle);

      if (typeof previous_collection === 'undefined') {
        return;
      }

      previous_collection_title = previous_collection.title;
    }

    if (previous_collection_title === 'Shop All') {
      return;
    }

    Array.from(this.elements.breadcrumbsContainers).forEach((breadcrumbsContainer) => {
      const previous = breadcrumbsContainer.querySelector('.breadcrumbs__previous');

      if (!breadcrumbsContainer || previous.innerHTML !== '') {
        return;
      }

      previous.innerHTML = `<a href="${document.referrer}">${previous_collection_title}</a>`;

      breadcrumbsContainer.querySelector('.breadcrumbs__dynamic').classList.remove('visually-hidden');
    });
  };
}
